const styles = {
  container: {
    backgroundColor: "#fff",
    width: "100%",
    boxShadow: "5px 0px 24px 0px rgba(208, 216, 243, 0.6)",
    position: "sticky",
    top: 0,
    zIndex: 1,
    display: "flex",
    flexDirection: "row",
  },
  logoContainer: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    paddingRight: 30,
  },
  logoContent: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
  },
  previewDeviceContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexGrow: 1,
  },
  buyActionContainer: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  color: {
    active: "#2b90ff",
    inactive: "#737e85",
  },
};

export default styles;
